import socket from '@/plugins/socket'

export default {
  init: (state, matchId) => {
    if (matchId) {
      const include = [
        { column: 'teamHomeId' },
        { column: 'teamAwayId' },
        { column: 'dayId' },
        { module: 'Action' },
        { module: 'Squad' },
        { module: 'Group' },
        { module: 'Round' },
        { module: 'CompetitionSeason' },
        { module: 'Competition' },
        { module: 'User' }
      ]
      socket.get('SportFootballMatch', 'Sport/Football/Match/load', { id: matchId, include: include })
    }
  },

  put (state, match) { socket.put('SportFootballMatch', 'Sport/Football/Match/loadMatch', match) },

  postAction ({ getters, dispatch }, action) {
    socket.post('SportFootballAction', 'Sport/Football/Match/loadAction', action)

    if (action.typeId === 21 && action.active === true) {
      dispatch('put', { id: action.matchId, statusId: 4 })
    }

    const goal = action.goal && action.active && !action.canceled
    if (goal) {
      let actions = getters.actions(action.matchId).filter(act => act.goal && !act.canceled && act.active)
      actions = actions.slice()
      actions.push(action)

      dispatch('updateScore', { actions, matchId: action.matchId })
    }

    const penalty = action.typeId === 6 && action.detail2Id === 8 && action.active
    if (penalty) {
      let actions = getters.actions(action.matchId).filter(act => act.typeId === 6 && act.detail2Id === 8 && act.active)
      actions = actions.slice()
      actions.push(action)

      dispatch('updateScoreFifth', { actions, matchId: action.matchId })
    }

    const statistics = (action.typeId === 1 || [2, 3, 4, 12].indexOf(action.originId) || [13].indexOf(action.originId) > -1 || action.typeId === 11) && action.active && !action.canceled
    if (statistics) {
      let actions = getters.actions(action.matchId).filter(act => (act.typeId === 1 || [2, 3, 4, 12].indexOf(act.originId) || [13].indexOf(act.originId) > -1 || action.typeId === 11) && act.active && !act.canceled && act.id !== action.id)
      actions = actions.slice()
      actions.push(action)

      dispatch('updateStatistics', { actions, matchId: action.matchId })
    }
  },
  putAction ({ getters, dispatch }, action) {
    socket.put('SportFootballAction', 'Sport/Football/Match/loadAction', action)

    const actionOld = Object.assign({}, getters.action(action.id))
    const actionNew = Object.assign({}, actionOld)
    Object.assign(actionNew, action)

    const goalOld = actionOld.goal && actionOld.active && !actionOld.canceled
    const goalNew = actionNew.goal && actionNew.active && !actionNew.canceled

    if (goalOld || goalNew) {
      let actions = getters.actions(actionNew.matchId).filter(act => act.goal && !act.canceled && act.active && act.id !== action.id)
      actions = actions.slice()
      if (goalNew) {
        actions.push(actionNew)
      }

      dispatch('updateScore', { actions, matchId: actionNew.matchId })
    }

    const penaltyOld = actionOld.typeId === 6 && actionOld.detail2Id === 8 && actionOld.active
    const penaltyNew = actionNew.typeId === 6 && actionNew.detail2Id === 8 && actionNew.active

    if ((penaltyOld || penaltyNew)) {
      let actions = getters.actions(actionNew.matchId).filter(act => act.typeId === 6 && act.detail2Id === 8 && act.active && act.id !== action.id)
      actions = actions.slice()
      if (penaltyNew) {
        actions.push(actionNew)
      }

      dispatch('updateScoreFifth', { actions, matchId: actionNew.matchId })
    }

    const statOld = (actionOld.typeId === 1 || [2, 3, 4, 12].indexOf(actionOld.originId) || [13].indexOf(actionOld.originId) > -1 || action.typeId === 11) && actionOld.active && !actionOld.canceled
    const statNew = (actionNew.typeId === 1 || [2, 3, 4, 12].indexOf(actionNew.originId) || [13].indexOf(actionNew.originId) > -1 || action.typeId === 11) && actionNew.active && !actionNew.canceled

    if ((statOld || statNew)) {
      let actions = getters.actions(actionNew.matchId).filter(act => (act.typeId === 1 || [2, 3, 4, 12].indexOf(act.originId) || [13].indexOf(act.originId) > -1 || action.typeId === 11) && act.active && !act.canceled && act.id !== action.id)
      actions = actions.slice()
      if (statNew) {
        actions.push(actionNew)
      }

      dispatch('updateStatistics', { actions, matchId: actionNew.matchId })
    }
  },

  updateScore ({ getters, dispatch }, { actions, matchId }) {
    const match = getters.match(matchId)

    const scoreHomeFirst = actions.filter(act => act.teamId === match.teamHomeId && (act.statusId === 7)).length
    const scoreHomeSecond = actions.filter(act => act.teamId === match.teamHomeId && (act.statusId === 8)).length
    const scoreHomeFourth = actions.filter(act => act.teamId === match.teamHomeId && (act.statusId === 9 || act.statusId === 10)).length
    const scoreAwayFirst = actions.filter(act => act.teamId === match.teamAwayId && (act.statusId === 7)).length
    const scoreAwaySecond = actions.filter(act => act.teamId === match.teamAwayId && (act.statusId === 8)).length
    const scoreAwayFourth = actions.filter(act => act.teamId === match.teamAwayId && (act.statusId === 9 || act.statusId === 10)).length

    const data = { id: match.id }
    let update = false

    if (scoreHomeFirst !== match.scoreHomeFirst) {
      data.scoreHomeFirst = scoreHomeFirst
      update = true
    }
    if (scoreAwayFirst !== match.scoreAwayFirst) {
      data.scoreAwayFirst = scoreAwayFirst
      update = true
    }

    if ((scoreHomeFirst + scoreHomeSecond) !== (match.scoreHomeFirst + match.scoreHomeSecond)) {
      data.scoreHomeSecond = (scoreHomeFirst + scoreHomeSecond)
      update = true
    }
    if ((scoreAwayFirst + scoreAwaySecond) !== (match.scoreAwayFirst + match.scoreAwaySecond)) {
      data.scoreAwaySecond = (scoreAwayFirst + scoreAwaySecond)
      update = true
    }

    const status = match.statusId
    const scoresExtra = [9, 10, 11, 13, 14, 15, 16]
    if (scoreHomeFourth + scoreAwayFourth > 0 || scoresExtra.indexOf(status) > -1) {
      if ((scoreHomeFirst + scoreHomeSecond + scoreHomeFourth) !== (match.scoreHomeFirst + match.scoreHomeSecond + match.scoreHomeFourth)) {
        data.scoreHomeFourth = (scoreHomeFirst + scoreHomeSecond + scoreHomeFourth)
        update = true
      }
      if ((scoreAwayFirst + scoreAwaySecond + scoreAwayFourth) !== (match.scoreAwayFirst + match.scoreAwaySecond + match.scoreAwayFourth)) {
        data.scoreAwayFourth = (scoreAwayFirst + scoreAwaySecond + scoreAwayFourth)
        update = true
      }
    }

    if (update) {
      dispatch('put', data)
    }
  },
  updateScoreFifth ({ getters, dispatch }, { actions, matchId }) {
    const match = getters.match(matchId)
    const scoreHomeFifth = actions.filter(act => act.teamId === match.teamHomeId && act.detail2Id === 8).length
    const scoreAwayFifth = actions.filter(act => act.teamId === match.teamAwayId && act.detail2Id === 8).length

    const data = { id: match.id }
    let update = false
    if (scoreHomeFifth !== match.scoreHomeFifth) {
      data.scoreHomeFifth = scoreHomeFifth
      update = true
    }
    if (scoreAwayFifth !== match.scoreAwayFifth) {
      data.scoreAwayFifth = scoreAwayFifth
      update = true
    }

    if (update) {
      dispatch('put', data)
    }
  },
  updateStatistics ({ state, getters, dispatch }, { actions, matchId }) {
    const match = getters.match(matchId)

    const data = Object.assign({}, state.matchsActionsStatistics.find((matchSearch) => { return match.id === matchSearch.id }))
    data.shotInHome = match.shotInHome - data.shotInHome
    data.shotInAway = match.shotInAway - data.shotInAway
    data.shotOutHome = match.shotOutHome - data.shotOutHome
    data.shotOutAway = match.shotOutAway - data.shotOutAway
    data.freekickHome = match.freekickHome - data.freekickHome
    data.freekickAway = match.freekickAway - data.freekickAway
    data.cornerHome = match.cornerHome - data.cornerHome
    data.cornerAway = match.cornerAway - data.cornerAway
    data.offsideHome = match.offsideHome - data.offsideHome
    data.offsideAway = match.offsideAway - data.offsideAway
    data.foulHome = match.foulHome - data.foulHome
    data.foulAway = match.foulAway - data.foulAway

    for (const i in actions) {
      const action = actions[i]
      let team
      if (action.teamId === match.teamHomeId) {
        team = 'Home'
      }
      if (action.teamId === match.teamAwayId) {
        team = 'Away'
      }

      if (team) {
        if (action.typeId === 1 && action.destinationId === 1) {
          data['shotIn' + team]++
        }
        if (action.typeId === 1 && [2, 3, 4].indexOf(action.destinationId) > -1) {
          data['shotOut' + team]++
        }
        if ([2, 3, 4, 12].indexOf(action.originId) > -1) {
          data['freekick' + team]++
        }
        if ([13].indexOf(action.originId) > -1) {
          data['corner' + team]++
        }
        if (action.typeId === 11) {
          data['foul' + team]++
        }
      }
    }

    dispatch('put', data)
  }
}
